/**
 * AOGEN phone → country dial (all countries) + national number.
 * Figma-style pill row; stores E.164 in the named field.
 */
(function () {
  /* ISO 3166-1 alpha-2 + E.164 dial (common calling codes). */
  var DIALS = [
    ['AF', '+93', 'Afghanistan'],
    ['AL', '+355', 'Albania'],
    ['DZ', '+213', 'Algeria'],
    ['AS', '+1', 'American Samoa'],
    ['AD', '+376', 'Andorra'],
    ['AO', '+244', 'Angola'],
    ['AI', '+1', 'Anguilla'],
    ['AG', '+1', 'Antigua & Barbuda'],
    ['AR', '+54', 'Argentina'],
    ['AM', '+374', 'Armenia'],
    ['AW', '+297', 'Aruba'],
    ['AU', '+61', 'Australia'],
    ['AT', '+43', 'Austria'],
    ['AZ', '+994', 'Azerbaijan'],
    ['BS', '+1', 'Bahamas'],
    ['BH', '+973', 'Bahrain'],
    ['BD', '+880', 'Bangladesh'],
    ['BB', '+1', 'Barbados'],
    ['BY', '+375', 'Belarus'],
    ['BE', '+32', 'Belgium'],
    ['BZ', '+501', 'Belize'],
    ['BJ', '+229', 'Benin'],
    ['BM', '+1', 'Bermuda'],
    ['BT', '+975', 'Bhutan'],
    ['BO', '+591', 'Bolivia'],
    ['BA', '+387', 'Bosnia'],
    ['BW', '+267', 'Botswana'],
    ['BR', '+55', 'Brazil'],
    ['IO', '+246', 'British Indian Ocean'],
    ['VG', '+1', 'British Virgin Islands'],
    ['BN', '+673', 'Brunei'],
    ['BG', '+359', 'Bulgaria'],
    ['BF', '+226', 'Burkina Faso'],
    ['BI', '+257', 'Burundi'],
    ['KH', '+855', 'Cambodia'],
    ['CM', '+237', 'Cameroon'],
    ['CA', '+1', 'Canada'],
    ['CV', '+238', 'Cape Verde'],
    ['KY', '+1', 'Cayman Islands'],
    ['CF', '+236', 'Central African Republic'],
    ['TD', '+235', 'Chad'],
    ['CL', '+56', 'Chile'],
    ['CN', '+86', 'China'],
    ['CO', '+57', 'Colombia'],
    ['KM', '+269', 'Comoros'],
    ['CG', '+242', 'Congo'],
    ['CD', '+243', 'Congo (DRC)'],
    ['CK', '+682', 'Cook Islands'],
    ['CR', '+506', 'Costa Rica'],
    ['CI', '+225', 'Côte d’Ivoire'],
    ['HR', '+385', 'Croatia'],
    ['CU', '+53', 'Cuba'],
    ['CW', '+599', 'Curaçao'],
    ['CY', '+357', 'Cyprus'],
    ['CZ', '+420', 'Czechia'],
    ['DK', '+45', 'Denmark'],
    ['DJ', '+253', 'Djibouti'],
    ['DM', '+1', 'Dominica'],
    ['DO', '+1', 'Dominican Republic'],
    ['EC', '+593', 'Ecuador'],
    ['EG', '+20', 'Egypt'],
    ['SV', '+503', 'El Salvador'],
    ['GQ', '+240', 'Equatorial Guinea'],
    ['ER', '+291', 'Eritrea'],
    ['EE', '+372', 'Estonia'],
    ['SZ', '+268', 'Eswatini'],
    ['ET', '+251', 'Ethiopia'],
    ['FK', '+500', 'Falkland Islands'],
    ['FO', '+298', 'Faroe Islands'],
    ['FJ', '+679', 'Fiji'],
    ['FI', '+358', 'Finland'],
    ['FR', '+33', 'France'],
    ['GF', '+594', 'French Guiana'],
    ['PF', '+689', 'French Polynesia'],
    ['GA', '+241', 'Gabon'],
    ['GM', '+220', 'Gambia'],
    ['GE', '+995', 'Georgia'],
    ['DE', '+49', 'Germany'],
    ['GH', '+233', 'Ghana'],
    ['GI', '+350', 'Gibraltar'],
    ['GR', '+30', 'Greece'],
    ['GL', '+299', 'Greenland'],
    ['GD', '+1', 'Grenada'],
    ['GP', '+590', 'Guadeloupe'],
    ['GU', '+1', 'Guam'],
    ['GT', '+502', 'Guatemala'],
    ['GG', '+44', 'Guernsey'],
    ['GN', '+224', 'Guinea'],
    ['GW', '+245', 'Guinea-Bissau'],
    ['GY', '+592', 'Guyana'],
    ['HT', '+509', 'Haiti'],
    ['HN', '+504', 'Honduras'],
    ['HK', '+852', 'Hong Kong'],
    ['HU', '+36', 'Hungary'],
    ['IS', '+354', 'Iceland'],
    ['IN', '+91', 'India'],
    ['ID', '+62', 'Indonesia'],
    ['IR', '+98', 'Iran'],
    ['IQ', '+964', 'Iraq'],
    ['IE', '+353', 'Ireland'],
    ['IM', '+44', 'Isle of Man'],
    ['IL', '+972', 'Israel'],
    ['IT', '+39', 'Italy'],
    ['JM', '+1', 'Jamaica'],
    ['JP', '+81', 'Japan'],
    ['JE', '+44', 'Jersey'],
    ['JO', '+962', 'Jordan'],
    ['KZ', '+7', 'Kazakhstan'],
    ['KE', '+254', 'Kenya'],
    ['KI', '+686', 'Kiribati'],
    ['XK', '+383', 'Kosovo'],
    ['KW', '+965', 'Kuwait'],
    ['KG', '+996', 'Kyrgyzstan'],
    ['LA', '+856', 'Laos'],
    ['LV', '+371', 'Latvia'],
    ['LB', '+961', 'Lebanon'],
    ['LS', '+266', 'Lesotho'],
    ['LR', '+231', 'Liberia'],
    ['LY', '+218', 'Libya'],
    ['LI', '+423', 'Liechtenstein'],
    ['LT', '+370', 'Lithuania'],
    ['LU', '+352', 'Luxembourg'],
    ['MO', '+853', 'Macao'],
    ['MG', '+261', 'Madagascar'],
    ['MW', '+265', 'Malawi'],
    ['MY', '+60', 'Malaysia'],
    ['MV', '+960', 'Maldives'],
    ['ML', '+223', 'Mali'],
    ['MT', '+356', 'Malta'],
    ['MH', '+692', 'Marshall Islands'],
    ['MQ', '+596', 'Martinique'],
    ['MR', '+222', 'Mauritania'],
    ['MU', '+230', 'Mauritius'],
    ['YT', '+262', 'Mayotte'],
    ['MX', '+52', 'Mexico'],
    ['FM', '+691', 'Micronesia'],
    ['MD', '+373', 'Moldova'],
    ['MC', '+377', 'Monaco'],
    ['MN', '+976', 'Mongolia'],
    ['ME', '+382', 'Montenegro'],
    ['MS', '+1', 'Montserrat'],
    ['MA', '+212', 'Morocco'],
    ['MZ', '+258', 'Mozambique'],
    ['MM', '+95', 'Myanmar'],
    ['NA', '+264', 'Namibia'],
    ['NR', '+674', 'Nauru'],
    ['NP', '+977', 'Nepal'],
    ['NL', '+31', 'Netherlands'],
    ['NC', '+687', 'New Caledonia'],
    ['NZ', '+64', 'New Zealand'],
    ['NI', '+505', 'Nicaragua'],
    ['NE', '+227', 'Niger'],
    ['NG', '+234', 'Nigeria'],
    ['NU', '+683', 'Niue'],
    ['NF', '+672', 'Norfolk Island'],
    ['KP', '+850', 'North Korea'],
    ['MK', '+389', 'North Macedonia'],
    ['MP', '+1', 'Northern Mariana Islands'],
    ['NO', '+47', 'Norway'],
    ['OM', '+968', 'Oman'],
    ['PK', '+92', 'Pakistan'],
    ['PW', '+680', 'Palau'],
    ['PS', '+970', 'Palestine'],
    ['PA', '+507', 'Panama'],
    ['PG', '+675', 'Papua New Guinea'],
    ['PY', '+595', 'Paraguay'],
    ['PE', '+51', 'Peru'],
    ['PH', '+63', 'Philippines'],
    ['PL', '+48', 'Poland'],
    ['PT', '+351', 'Portugal'],
    ['PR', '+1', 'Puerto Rico'],
    ['QA', '+974', 'Qatar'],
    ['RE', '+262', 'Réunion'],
    ['RO', '+40', 'Romania'],
    ['RU', '+7', 'Russia'],
    ['RW', '+250', 'Rwanda'],
    ['WS', '+685', 'Samoa'],
    ['SM', '+378', 'San Marino'],
    ['ST', '+239', 'São Tomé & Príncipe'],
    ['SA', '+966', 'Saudi Arabia'],
    ['SN', '+221', 'Senegal'],
    ['RS', '+381', 'Serbia'],
    ['SC', '+248', 'Seychelles'],
    ['SL', '+232', 'Sierra Leone'],
    ['SG', '+65', 'Singapore'],
    ['SX', '+1', 'Sint Maarten'],
    ['SK', '+421', 'Slovakia'],
    ['SI', '+386', 'Slovenia'],
    ['SB', '+677', 'Solomon Islands'],
    ['SO', '+252', 'Somalia'],
    ['ZA', '+27', 'South Africa'],
    ['KR', '+82', 'South Korea'],
    ['SS', '+211', 'South Sudan'],
    ['ES', '+34', 'Spain'],
    ['LK', '+94', 'Sri Lanka'],
    ['BL', '+590', 'St. Barthélemy'],
    ['SH', '+290', 'St. Helena'],
    ['KN', '+1', 'St. Kitts & Nevis'],
    ['LC', '+1', 'St. Lucia'],
    ['MF', '+590', 'St. Martin'],
    ['PM', '+508', 'St. Pierre & Miquelon'],
    ['VC', '+1', 'St. Vincent'],
    ['SD', '+249', 'Sudan'],
    ['SR', '+597', 'Suriname'],
    ['SE', '+46', 'Sweden'],
    ['CH', '+41', 'Switzerland'],
    ['SY', '+963', 'Syria'],
    ['TW', '+886', 'Taiwan'],
    ['TJ', '+992', 'Tajikistan'],
    ['TZ', '+255', 'Tanzania'],
    ['TH', '+66', 'Thailand'],
    ['TL', '+670', 'Timor-Leste'],
    ['TG', '+228', 'Togo'],
    ['TK', '+690', 'Tokelau'],
    ['TO', '+676', 'Tonga'],
    ['TT', '+1', 'Trinidad & Tobago'],
    ['TN', '+216', 'Tunisia'],
    ['TR', '+90', 'Turkey'],
    ['TM', '+993', 'Turkmenistan'],
    ['TC', '+1', 'Turks & Caicos'],
    ['TV', '+688', 'Tuvalu'],
    ['VI', '+1', 'U.S. Virgin Islands'],
    ['UG', '+256', 'Uganda'],
    ['UA', '+380', 'Ukraine'],
    ['AE', '+971', 'United Arab Emirates'],
    ['GB', '+44', 'United Kingdom'],
    ['US', '+1', 'United States'],
    ['UY', '+598', 'Uruguay'],
    ['UZ', '+998', 'Uzbekistan'],
    ['VU', '+678', 'Vanuatu'],
    ['VA', '+39', 'Vatican City'],
    ['VE', '+58', 'Venezuela'],
    ['VN', '+84', 'Vietnam'],
    ['WF', '+681', 'Wallis & Futuna'],
    ['YE', '+967', 'Yemen'],
    ['ZM', '+260', 'Zambia'],
    ['ZW', '+263', 'Zimbabwe'],
  ];

  function flagEmoji(iso) {
    var s = String(iso || '').toUpperCase();
    if (s.length !== 2) return '';
    return String.fromCodePoint(127397 + s.charCodeAt(0), 127397 + s.charCodeAt(1));
  }

  function defaultIso(root) {
    var fromBlock = (root && root.getAttribute('data-country')) || '';
    var iso = String(fromBlock || '').trim().toUpperCase();
    if (iso.length === 2) return iso;
    return 'US';
  }

  function digitsOnly(s) {
    return String(s || '').replace(/\D+/g, '');
  }

  function dialForIso(iso) {
    var code = String(iso || '').toUpperCase();
    for (var i = 0; i < DIALS.length; i++) {
      if (DIALS[i][0] === code) return DIALS[i][1];
    }
    return '+1';
  }

  function composeE164(dial, national) {
    var d = String(dial || '').trim();
    if (d.charAt(0) !== '+') d = '+' + d.replace(/^\+/, '');
    var n = digitsOnly(national).replace(/^0+/, '');
    if (!n) return '';
    return d + n;
  }

  function buildPhoneWidget(hiddenInput, root) {
    var wrap = document.createElement('div');
    wrap.className = 'amc-aogen-phone';
    wrap.setAttribute('data-amc-aogen-phone', '');

    var dial = document.createElement('select');
    dial.className = 'amc-aogen-phone__dial';
    dial.setAttribute('aria-label', 'Country');
    var pref = defaultIso(root);
    DIALS.forEach(function (row) {
      var opt = document.createElement('option');
      opt.value = row[0];
      opt.textContent = flagEmoji(row[0]) + '  ' + row[2];
      opt.title = row[2] + ' (' + row[1] + ')';
      opt.setAttribute('data-dial', row[1]);
      if (row[0] === pref) opt.selected = true;
      dial.appendChild(opt);
    });

    var number = document.createElement('div');
    number.className = 'amc-aogen-phone__number';

    var prefix = document.createElement('span');
    prefix.className = 'amc-aogen-phone__prefix';
    prefix.setAttribute('aria-hidden', 'true');

    var national = document.createElement('input');
    national.type = 'tel';
    national.className = 'amc-aogen-phone__national';
    national.setAttribute('inputmode', 'numeric');
    national.setAttribute('pattern', '[0-9]*');
    national.setAttribute('autocomplete', 'tel-national');
    /* Always this copy — never inherit section sample numbers like "555 014 8820". */
    national.setAttribute('placeholder', 'Your phone number');
    national.setAttribute('aria-label', 'Your phone number');
    national.value = '';
    /* Flatten: no nested white chrome from AOGEN / UA styles */
    national.style.setProperty('background', 'transparent', 'important');
    national.style.setProperty('background-color', 'transparent', 'important');
    national.style.setProperty('border', 'none', 'important');
    national.style.setProperty('border-radius', '0', 'important');
    national.style.setProperty('box-shadow', 'none', 'important');
    national.style.setProperty('outline', 'none', 'important');
    national.style.setProperty('padding', '0', 'important');
    if (hiddenInput && hiddenInput.required) national.required = true;

    function currentDial() {
      var opt = dial.options[dial.selectedIndex];
      return (opt && opt.getAttribute('data-dial')) || dialForIso(dial.value);
    }

    function syncPrefix() {
      prefix.textContent = currentDial();
    }

    function digitsOnlyNational() {
      var next = digitsOnly(national.value);
      if (national.value !== next) national.value = next;
      return next;
    }

    function sync() {
      digitsOnlyNational();
      if (hiddenInput) hiddenInput.value = composeE164(currentDial(), national.value);
    }

    dial.addEventListener('change', function () {
      syncPrefix();
      sync();
    });
    national.addEventListener('beforeinput', function (e) {
      if (e.inputType && e.inputType.indexOf('insert') === 0 && e.data && /\D/.test(e.data)) {
        e.preventDefault();
      }
    });
    national.addEventListener('keypress', function (e) {
      if (e.ctrlKey || e.metaKey || e.altKey) return;
      var ch = e.key || String.fromCharCode(e.which || e.keyCode);
      if (ch && ch.length === 1 && /\D/.test(ch)) e.preventDefault();
    });
    national.addEventListener('paste', function (e) {
      e.preventDefault();
      var text = '';
      try {
        text = (e.clipboardData || window.clipboardData).getData('text') || '';
      } catch (_) {}
      var dig = digitsOnly(text);
      var start = national.selectionStart || 0;
      var end = national.selectionEnd || 0;
      var cur = String(national.value || '');
      national.value = digitsOnly(cur.slice(0, start) + dig + cur.slice(end));
      sync();
    });
    national.addEventListener('input', sync);
    national.addEventListener('change', sync);

    number.appendChild(prefix);
    number.appendChild(national);
    wrap.appendChild(dial);
    wrap.appendChild(number);

    syncPrefix();
    sync();
    return wrap;
  }

  function enhanceInput(input, root) {
    if (!input || input.nodeType !== 1) return;
    if (input.getAttribute('data-amc-phone-enhanced') === '1') return;
    if (input.getAttribute('data-amc-phone-skip') === '1') return;
    if (input.getAttribute('data-amc-hub-people-digits') === '1') return;
    if (input.closest && input.closest('.amc-aogen-phone')) return;

    var name = String(input.getAttribute('name') || '').toLowerCase();
    if (name.indexOf('how_many') !== -1 || (name.indexOf('people') !== -1 && name !== 'phone')) {
      return;
    }
    var labText = '';
    try {
      var lab = input.closest('label');
      labText = lab ? String(lab.textContent || '').replace(/\s+/g, ' ').trim().toLowerCase() : '';
    } catch (_) {}
    if (/how many|people joining|joining\?/.test(labText) && name !== 'phone') return;

    var aogenPhone = input.closest && input.closest('.aogen-forms-phone');
    if (aogenPhone) {
      enhanceAogenNativePhone(aogenPhone, root);
      return;
    }

    if (String(input.type || '').toLowerCase() !== 'tel' && name !== 'phone') return;
    if (input.type === 'hidden' && name !== 'phone') return;

    input.setAttribute('data-amc-phone-enhanced', '1');
    input.type = 'hidden';
    input.removeAttribute('required');

    var wrap = buildPhoneWidget(input, root);
    var parent = input.parentNode;
    if (!parent) return;
    parent.insertBefore(wrap, input);
    wrap.appendChild(input);
  }

  function enhanceAogenNativePhone(phoneWrap, root) {
    if (!phoneWrap || phoneWrap.getAttribute('data-amc-phone-enhanced') === '1') return;
    var hidden =
      phoneWrap.querySelector('input[data-aogen-phone-e164]') ||
      phoneWrap.querySelector('input[type="hidden"][name]') ||
      phoneWrap.querySelector('input[name="phone"]');
    /* Native dial+national without hidden → still replace with our widget. */
    if (!hidden) {
      var nationalOnly = phoneWrap.querySelector(
        'input.aogen-forms-phone-national, input[type="tel"], input[name="phone"]'
      );
      if (!nationalOnly || !phoneWrap.parentNode) return;
      phoneWrap.setAttribute('data-amc-phone-enhanced', '1');
      nationalOnly.setAttribute('data-amc-phone-enhanced', '1');
      nationalOnly.type = 'hidden';
      nationalOnly.removeAttribute('required');
      var widgetFallback = buildPhoneWidget(nationalOnly, root);
      widgetFallback.appendChild(nationalOnly);
      phoneWrap.parentNode.insertBefore(widgetFallback, phoneWrap);
      phoneWrap.remove();
      return;
    }
    phoneWrap.setAttribute('data-amc-phone-enhanced', '1');
    hidden.setAttribute('data-amc-phone-enhanced', '1');
    var widget = buildPhoneWidget(hidden, root);
    widget.appendChild(hidden);
    if (!phoneWrap.parentNode) return;
    phoneWrap.parentNode.insertBefore(widget, phoneWrap);
    phoneWrap.remove();
  }

  function enhanceRoot(root) {
    if (!root || !root.querySelectorAll) return;
    root.querySelectorAll('.aogen-forms-phone').forEach(function (ph) {
      enhanceAogenNativePhone(ph, root);
    });
    root.querySelectorAll('input[type="tel"], input[name="phone"]').forEach(function (inp) {
      enhanceInput(inp, root);
    });
  }

  function enhanceAll(scope) {
    var root = scope && scope.querySelectorAll ? scope : document;
    root.querySelectorAll('.aogen-forms-block').forEach(enhanceRoot);
    /* Fallback: AOGEN may mount fields into hosts without re-adding the block node. */
    root
      .querySelectorAll(
        '.amc-po__form-card-body, .amc-eif__form, .amc-ab__form, .aogen-forms-form, [data-aogen-fields], .aogen-forms-fields'
      )
      .forEach(enhanceRoot);
  }

  function enhanceFromNode(node) {
    if (!node || node.nodeType !== 1) return;
    if (node.matches && node.matches('input[type="tel"], input[name="phone"]')) {
      enhanceInput(node, node.closest('.aogen-forms-block') || document);
      return;
    }
    if (node.matches && node.matches('.aogen-forms-phone')) {
      enhanceAogenNativePhone(node, node.closest('.aogen-forms-block') || document);
      return;
    }
    var block =
      (node.classList && node.classList.contains('aogen-forms-block') && node) ||
      (node.closest && node.closest('.aogen-forms-block'));
    if (block) {
      enhanceRoot(block);
      return;
    }
    if (node.querySelectorAll) enhanceAll(node);
  }

  function boot() {
    enhanceAll(document);
    /* AOGEN definition fetch is async — retry while plain phone inputs remain. */
    var tries = 0;
    var retry = setInterval(function () {
      tries += 1;
      enhanceAll(document);
      var plainLeft = document.querySelector(
        '.aogen-forms-block input[name="phone"]:not([data-amc-phone-enhanced]),' +
          '.aogen-forms-block input[type="tel"]:not([data-amc-phone-enhanced]),' +
          '.amc-po__form-card-body input[name="phone"]:not([data-amc-phone-enhanced]),' +
          '.amc-po__form-card-body input[type="tel"]:not([data-amc-phone-enhanced])'
      );
      if (!plainLeft || tries >= 24) clearInterval(retry);
    }, 400);

    if (typeof MutationObserver === 'undefined') return;
    var obs = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var m = mutations[i];
        if (m.type !== 'childList') continue;
        m.addedNodes.forEach(enhanceFromNode);
      }
    });
    obs.observe(document.documentElement, { childList: true, subtree: true });
  }

  document.addEventListener('amc:aogen-phone-enhance', function (e) {
    var scope = (e && e.detail && e.detail.root) || (e && e.target) || document;
    enhanceAll(scope);
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
